module.exports = __webpack_public_path__ + "img/in.37521fdc.jpg";